import React from 'react'

import { createBrowserRouter, RouteObject } from 'react-router-dom'
import {
  UnknownErrorPage,
  EntityTransaction,
  PrivacyPolicyAcceptance,
  Home,
  UnknownErrorPageContextAware,
  PrivacyPolicyAcceptanceSuccess,
  PrivacyPolicy,
  YourPersonalData,
  FrequentQuestions,
  ReportsHistory,
  ReportLoader,
  UnavailableReport,
  UnavailableService,
  MyServices,
  ServiceDetails,
  ServiceResponse,
  NewService,
  FeedbackPage,
  EntityMenu,
  SuccessReportRequested,
  SuccessEmailSent,
  HelpCenter,
  PdfViewerPage,
  PrivacyPolicyAcceptanceError,
  UnavailableFeature,
  ManageNotifications,
} from 'pages'
import { AppInitializerWrapper, PrivacyPolicyAcceptanceInitializer } from 'components'
import { Routes } from 'common/constants'
import { ProductDetailsProviders } from 'pages/product-details/components/ProductDetailsProviders'

const SuccessFeedback = () => <FeedbackPage type="success" />

const ErrorFeedback = () => <FeedbackPage type="error" />

const routes: RouteObject[] = [
  {
    path: Routes.ROOT,
    Component: AppInitializerWrapper,
    errorElement: <UnknownErrorPage />,
    children: [
      {
        path: Routes.ENTITY,
        Component: EntityMenu,
      },
      {
        path: Routes.ENTITY_TRANSACTION,
        Component: EntityTransaction,
      },
      {
        path: Routes.HOME,
        Component: Home,
      },
      {
        path: Routes.NOTIFICATIONS_MANAGEMENT,
        children: [
          {
            index: true,
            Component: ManageNotifications,
          },
          {
            path: `:productId`,
            Component: ProductDetailsProviders,
          },
        ],
      },
      {
        path: Routes.YOUR_PERSONAL_DATA,
        Component: YourPersonalData,
      },
      {
        path: Routes.FREQUENT_QUESTIONS,
        Component: FrequentQuestions,
      },
      {
        path: Routes.REPORTS_HISTORY,
        Component: ReportsHistory,
      },
      {
        path: Routes.REPORT_LOADER,
        Component: ReportLoader,
      },
      {
        path: Routes.UNAVAILABLE_SERVICE,
        Component: UnavailableService,
      },
      {
        path: Routes.UNAVAILABLE_REPORT,
        Component: UnavailableReport,
      },
      {
        path: Routes.SUCCESS_REPORT_REQUESTED,
        Component: SuccessReportRequested,
      },
      {
        path: Routes.SUCCESS_EMAIL_SENT,
        Component: SuccessEmailSent,
      },
      {
        path: Routes.PRIVACY_POLICY,
        Component: PrivacyPolicy,
      },
      {
        path: Routes.MY_SERVICE_REQUESTS,
        Component: MyServices,
      },
      {
        path: Routes.SERVICE_DETAILS,
        Component: ServiceDetails,
      },
      {
        path: Routes.SERVICE_RESPONSE,
        Component: ServiceResponse,
      },
      {
        path: Routes.NEW_SERVICE,
        Component: NewService,
      },
      {
        path: Routes.SUCCES_SENDING_REPORT,
        Component: SuccessFeedback,
      },
      {
        path: Routes.ERROR_SENDING_REPORT,
        Component: ErrorFeedback,
      },
      {
        path: Routes.ERROR,
        Component: UnknownErrorPageContextAware,
      },
      {
        path: Routes.NEED_HELP,
        Component: HelpCenter,
      },
      {
        path: Routes.PDF_VIEWER,
        Component: PdfViewerPage,
      },
    ],
  },
  {
    path: Routes.PRIVACY_POLICY_ACCEPTANCE,
    Component: PrivacyPolicyAcceptanceInitializer,
    errorElement: <UnknownErrorPage />,
    children: [
      {
        index: true,
        Component: PrivacyPolicyAcceptance,
      },
      {
        path: Routes.PRIVACY_POLICY_ACCEPTANCE_SUCCESS,
        Component: PrivacyPolicyAcceptanceSuccess,
      },
      {
        path: Routes.PRIVACY_POLICY_ACCEPTANCE_PDF_VIEWER,
        Component: PdfViewerPage,
      },
      {
        path: Routes.PRIVACY_POLICY_ACCEPTANCE_ERROR,
        Component: PrivacyPolicyAcceptanceError,
      },
    ],
  },
  {
    path: Routes.UNAVAILABLE_FEATURE,
    Component: UnavailableFeature,
  },
  { path: Routes.UNKNOWN_ERROR, Component: UnknownErrorPage },
]

export const router = createBrowserRouter(routes)
